export const getFileExtension = (filename) => {
    let extension = filename;
    if(extension && extension !== ""){
     extension = extension ? extension?.split('.')?.pop() : '';
    }
    return extension;
}